import { css, useTheme } from '@fable/theme'

import mobileImg from 'assets/images/homepage/callout_main/club-mobile-view.webp'
import bookImg from 'assets/images/homepage/callout_main/club-book-cover.webp'
import readerEx from 'assets/images/homepage/callout_main/reader-example-green.webp'
import { useRef } from 'react'
import { useScroll, useTransform, motion } from 'framer-motion'

export const MLPClubCalloutImages = () => {
  const { mediaQueries } = useTheme()
  const ref = useRef(null)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['10% end', 'center center'],
  })

  const opacity = useTransform(scrollYProgress, [0, 0.25, 1], [0, 0, 1])
  const primaryY = useTransform(scrollYProgress, [0, 1], [75, 0])
  const secondaryY = useTransform(scrollYProgress, [0, 1], [100, 0])
  const rotateRev = useTransform(scrollYProgress, [0, 1], [0, -10])
  const rotate = useTransform(scrollYProgress, [0, 1], [0, 10])

  return (
    <div
      ref={ref}
      className={css`
        width: calc(100% + 48px);
        height: 100%;
        position: absolute;
        inset: auto auto 0 50%;
        transform: translateX(-50%);
        overflow: hidden;
        pointer-events: none;
        ${mediaQueries.mobileL} {
          width: 150%;
        }
      `}
    >
      <motion.img
        style={{ opacity, y: secondaryY, rotate: rotateRev }}
        className={css`
          max-width: 40.561vw;
          position: absolute;
          bottom: -2vw;
          left: 6vw;
          ${mediaQueries.mobileL} {
            bottom: -7vw;
            left: 12.5vw;
            max-width: 26.042vw;
          }
          ${mediaQueries.desktop} {
            bottom: -15%;
            left: 18%;
            max-width: 300px;
          }
        `}
        src={readerEx}
        alt="reader preview"
      />
      <motion.div
        style={{ y: primaryY, x: '-50%' }}
        className={css`
          max-width: 40.816vw;
          position: absolute;
          inset: auto auto -15.306vw 50%;
          transform: translateX(-50%);
          z-index: 5;
          ${mediaQueries.mobileL} {
            max-width: 22.222vw;
            bottom: -8.681vw;
          }
          ${mediaQueries.desktop} {
            max-width: 256px;
            bottom: -100px;
          }
        `}
      >
        <img
          className={css`
            display: block;
            width: 100%;
            position: relative;
            z-index: 1;
          `}
          src={mobileImg}
          alt="club mobile app preview"
        />
        <span
          className={css`
            display: block;
            width: 90%;
            height: 90%;
            position: absolute;
            border-radius: 40px;
            inset: 50% auto auto 50%;
            transform: translate(-50%, -50%);
            opacity: 0.5;
            box-shadow: 12px 0px 40px rgba(0, 0, 0, 0.5);
          `}
        />
      </motion.div>
      <motion.img
        style={{ opacity, y: secondaryY, rotate }}
        className={css`
          position: absolute;
          max-width: 45.918vw;
          bottom: -1vw;
          right: 7vw;
          border-radius: 2.215vw;
          ${mediaQueries.mobileL} {
            bottom: -2vw;
            right: 13vw;
            max-width: 26.042vw;
            border-radius: 1.215vw;
          }
          ${mediaQueries.desktop} {
            bottom: -5%;
            right: 18%;
            max-width: 300px;
            border-radius: 14px;
          }
        `}
        src={bookImg}
        alt="book cover"
      />
    </div>
  )
}
